import { render, staticRenderFns } from "./ApprovePurchase.vue?vue&type=template&id=5bbbd620&"
import script from "./ApprovePurchase.vue?vue&type=script&lang=js&"
export * from "./ApprovePurchase.vue?vue&type=script&lang=js&"
import style0 from "./ApprovePurchase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ApprovePurchase.vue"
export default component.exports